module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('_editor') === -1) ? _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "助力活动管理",
      "name": "list"
    }
  }, [_c('div', {
    staticClass: "content-bottom-padded"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-plus"
    },
    on: {
      "click": _vm.addBargains
    }
  }, [_vm._v("添加助力活动")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.dataList,
      "height": _vm.wheight - 230
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "title",
      "label": "活动名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "活动时间",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("datetime")(scope.row.begin_time, 'yyyy-MM-dd hh:mm:ss')) + " "), _c('br'), _vm._v(" " + _vm._s(_vm._f("datetime")(scope.row.end_time, 'yyyy-MM-dd hh:mm:ss')) + "\n          ")]
      }
    }], null, false, 1379592573)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item_name",
      "label": "产品名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "产品原价",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            ￥" + _vm._s(scope.row.mkt_price / 100) + "\n          ")]
      }
    }], null, false, 2968803974)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "产品底价",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            ￥" + _vm._s(scope.row.price / 100) + "\n          ")]
      }
    }], null, false, 4094454955)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "助力人数",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.people_range.min) + " ~ " + _vm._s(scope.row.people_range.max) + "\n          ")]
      }
    }], null, false, 859894128)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "limit_num",
      "label": "产品数量",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "order_num",
      "label": "已购数量",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.is_expired) ? _c('i', {
          staticClass: "iconfont icon-edit1",
          on: {
            "click": function($event) {
              return _vm.editBargains(scope.$index, scope.row)
            }
          }
        }) : _vm._e(), _vm._v(" "), (!scope.row.is_expired) ? _c('i', {
          staticClass: "iconfont icon-user-slash",
          on: {
            "click": function($event) {
              return _vm.terminateBargainsAction(scope.$index, scope.row)
            }
          }
        }, [_vm._v("废除")]) : _vm._e(), _vm._v(" "), _c('i', {
          staticClass: "mark iconfont icon-trash-alt1",
          on: {
            "click": function($event) {
              return _vm.deleteBargainsAction(scope.$index, scope.row)
            }
          }
        })]
      }
    }], null, false, 623223253)
  })], 1), _vm._v(" "), (_vm.total_count > _vm.params.pageSize) ? _c('div', {
    staticClass: "content-center content-padded"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "助力广告图",
      "name": "image"
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "label-position": "left"
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("只能上传jpg/png文件，且不超过2M （建议尺寸：617px * 214px）")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": _vm.handleImgChange
    }
  }, [(_vm.ad_pic) ? _c('img', {
    staticClass: "setting_pic",
    attrs: {
      "src": _vm.wximageurl + _vm.ad_pic
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])]), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgDialog,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeImgDialog
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "section-footer with-border content-center",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveAdPic
    }
  }, [_vm._v("保 存")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a0f40dda", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a0f40dda"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/bargain/index.vue
// module id = 2892
// module chunks = 0